import React from 'react';
import { observer } from 'mobx-react';

import { FormattedMessage } from "react-intl";

const CheckoutTotalWeight = ({}) => {
  return (
    <div className="CheckoutTotalWeight">
      <FormattedMessage
        id="checkout.totalWeight"
        defaultMessage="Total weight approx {weight} kg"
        values={{
          weight: weight,
        }}
      />
    </div>
  );
};

export default observer(CheckoutTotalWeight);
